/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.style = exports.name = exports.mapStateToProps = exports.FindADealer = void 0;

var react_1 = __importDefault(require("react"));

var brightsmith_core_1 = require("brightsmith-core");

var BrightsmithDb = brightsmith_core_1.Db.BrightsmithDb;
var name = 'FindADealer';
exports.name = name;

var FindADealer = function FindADealer(_ref) {
  var Frame = _ref.Frame,
      Text = _ref.Text,
      Image = _ref.Image,
      Button = _ref.Button,
      styles = _ref.styles;
  return /*#__PURE__*/function (_react_1$default$Comp) {
    _inherits(_class, _react_1$default$Comp);

    var _super = _createSuper(_class);

    function _class(props) {
      _classCallCheck(this, _class);

      return _super.call(this, props);
    }

    _createClass(_class, [{
      key: "renderDealerInfo",
      value: function renderDealerInfo(dealer, classes) {
        var name = dealer.name,
            address1 = dealer.address1,
            city = dealer.city,
            state = dealer.state,
            county = dealer.county,
            zip = dealer.zip,
            country = dealer.country,
            phone = dealer.phone,
            id = dealer.id,
            distanceInMiles = dealer.distanceInMiles;
        return react_1.default.createElement(Frame, {
          className: ['FindADealer__dealer-info', classes === null || classes === void 0 ? void 0 : classes.info],
          style: styles === null || styles === void 0 ? void 0 : styles.info
        }, react_1.default.createElement(Text, {
          className: ['FindADealer__distance', classes === null || classes === void 0 ? void 0 : classes.infoColor],
          style: styles === null || styles === void 0 ? void 0 : styles.infoColor
        }, "Distance ", distanceInMiles, " mi"), react_1.default.createElement(Text, {
          className: ['FindADealer__dealerName', classes === null || classes === void 0 ? void 0 : classes.infoBold],
          style: styles === null || styles === void 0 ? void 0 : styles.infoBold
        }, name), [address1, "".concat(city, ", ").concat(state, ", ").concat(zip), county, phone].map(function (row) {
          return react_1.default.createElement(Text, {
            className: ['FindADealer__dealerName', classes === null || classes === void 0 ? void 0 : classes.infoRegular],
            style: styles === null || styles === void 0 ? void 0 : styles.infoRegular
          }, row);
        }));
      }
    }, {
      key: "render",
      value: function render() {
        var _this = this;

        var _this$props = this.props,
            after = _this$props.after,
            before = _this$props.before,
            classes = _this$props.classes,
            _this$props$dealers = _this$props.dealers,
            dealers = _this$props$dealers === void 0 ? [] : _this$props$dealers;
        return react_1.default.createElement(Frame, {
          className: ['FindADealer__container', classes === null || classes === void 0 ? void 0 : classes.container],
          style: styles === null || styles === void 0 ? void 0 : styles.container
        }, before, react_1.default.createElement(Text, {
          className: ['FindADealer__title', classes === null || classes === void 0 ? void 0 : classes.title],
          style: styles === null || styles === void 0 ? void 0 : styles.title
        }, "Select A Club Car Dealer"), react_1.default.createElement(Image, {
          className: ['FindADealer__title', classes === null || classes === void 0 ? void 0 : classes.close],
          style: styles === null || styles === void 0 ? void 0 : styles.close
        }), react_1.default.createElement(Frame, {
          className: ['FindADealer__inner', classes === null || classes === void 0 ? void 0 : classes.inner],
          style: styles === null || styles === void 0 ? void 0 : styles.inner
        }, dealers.map(function (dealer) {
          return react_1.default.createElement(Frame, {
            className: ['FindADealer__dealer-row', classes === null || classes === void 0 ? void 0 : classes.row],
            style: styles === null || styles === void 0 ? void 0 : styles.row
          }, _this.renderDealerInfo(dealer, classes), react_1.default.createElement(Button, {
            className: ['FindADealer__dealer-select', classes === null || classes === void 0 ? void 0 : classes.select],
            style: styles === null || styles === void 0 ? void 0 : styles.select
          }));
        })), after);
      }
    }]);

    return _class;
  }(react_1.default.Component);
};

exports.FindADealer = FindADealer;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var api = state.api;
  var db = new BrightsmithDb(api);
  var dealers = db.getDealers();
  return {
    dealers: dealers
  };
};

exports.mapStateToProps = mapStateToProps;

var style = function style(theme) {
  var _a, _b;

  return {
    container: {},
    title: Object.assign({
      color: (_a = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _a === void 0 ? void 0 : _a.primary,
      fontSize: 30,
      fontWeight: '100',
      lineHeight: '45px'
    }, (_b = theme === null || theme === void 0 ? void 0 : theme.FindADealer) === null || _b === void 0 ? void 0 : _b.title)
  };
};

exports.style = style;